<template>
    <div class="static-page">
      Information Page Content here
    </div>
</template>

<script>

export default {
  name: 'Information',
  components: {
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
  @import "../style";
</style>
